// @flow
import React from "react";
// $FlowFixMe reactstrap doesn't declare these components but they are exported
import { Dropdown, DropdownMenu, DropdownToggle } from "reactstrap";
import "./dropdown.style.scss";

type Props = $Exact<{
  label: string | React$Node,
  position?: "left" | "right",
  direction?: "up" | "down" | "left" | "right",
  children: React$Node,
  disabled?: boolean,
  className?: string,
  hovered?: boolean,
}>;

type State = $Exact<{
  dropdownOpen: boolean,
}>;

class DropDown extends React.Component<Props, State> {
  state = {
    dropdownOpen: false,
  };

  toggle = (isOpen: boolean) => {
    this.setState({
      dropdownOpen: typeof isOpen === "boolean" ? isOpen : !this.state.dropdownOpen,
    });
  };

  get isSafari() {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  }

  render() {
    return (
      <div className={`dropdown-extended ${this.props.className || ""}`}>
        <Dropdown
          disabled={this.props.disabled}
          isOpen={this.state.dropdownOpen}
          toggle={this.toggle}
          direction={this.props.direction || "down"}
          onMouseOver={this.props.hovered ? () => this.toggle(true) : undefined}
          onFocus={this.props.hovered ? () => this.toggle(true) : undefined}
          onMouseLeave={this.props.hovered ? () => this.toggle(false) : undefined}
          onBlur={this.props.hovered ? () => this.toggle(false) : undefined}
        >
          <DropdownToggle
            disabled={this.props.disabled}
            tag="span"
            onClick={this.toggle}
            data-toggle="dropdown"
            aria-expanded={this.state.dropdownOpen}
            role="menu"
          >
            <div className="dropdown-button-label" role="menuitem" aria-label={this.props.label}>
              {this.props.label}
            </div>
          </DropdownToggle>
          <DropdownMenu
            onClick={this.toggle}
            className={
              this.isSafari
                ? "dropdown-menu-extended dropdown-menu-safari"
                : "dropdown-menu-extended"
            }
            right={this.props.position !== "right"}
          >
            {this.props.children}
          </DropdownMenu>
        </Dropdown>
      </div>
    );
  }
}

export default DropDown;
